import { j as s } from "../../jsx-runtime-B6kdoens.js";
import { c as l } from "../../index-CROKJrb5.js";
import { c as h, f as m } from "../../create-component-CBAeEoQ6.js";
import { IconRenderer as f } from "../Icon/index.js";
const d = l({
  base: "cur-px-4 cur-flex",
  variants: {
    state: {
      highlight: "cur-bg-surface-highlight cur-text-brand",
      critical: "cur-bg-surface-error cur-text-error",
      warning: "cur-bg-surface-warning cur-text-warning",
      success: "cur-bg-surface-success cur-text-success",
      light: null,
      dark: null
    },
    size: {
      sm: "cur-py-5",
      md: "cur-py-7"
    }
  }
}), w = h(
  "Highlight",
  m(
    ({
      as: c,
      children: e,
      className: t,
      icon: a,
      size: i = "md",
      state: u = "highlight",
      title: r,
      ...n
    }, o) => {
      const g = c || "div";
      return /* @__PURE__ */ s.jsxs(
        g,
        {
          ref: o,
          className: d({ size: i, state: u, className: t }),
          role: "alert",
          ...n,
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: "cur-grow-1 cur-w-full", children: [
              r && typeof r == "string" ? /* @__PURE__ */ s.jsx("div", { className: "cur-font-bold", children: r }) : r,
              e
            ] }),
            /* @__PURE__ */ s.jsx(f, { icon: a, className: "cur-shrink-0" })
          ]
        }
      );
    }
  )
);
export {
  w as Highlight
};
//# sourceMappingURL=index.js.map
